import React from 'react';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useGetWinnerList } from '@/hooks/sport-event/use-get-winner-list';

export const WinnerListSlider = () => {
	const t = useTranslations('General');
	const { winnerListForShow } = useGetWinnerList();
	return (
		<div className="sport-event__winner-list-slider">
			<div className="sport-event__winner-list-slider-title-group">
				<div className="sport-event__winner-list-slider-title">{t('lbl_KBWinList01')}</div>
			</div>
			<div className={clsx('sport-event__winner-list-slider-content')}>
				<div className="sport-event__winner-list-slider-table-wrapper">
					<div className="sport-event__winner-list-slider-announce">{t('lbl_KBWinList02')}</div>
					<div className="sport-event__winner-list-slider-divider"></div>
					<div className="sport-event__winner-list-slider-table">
						{winnerListForShow?.map((winner, idx) => (
							<div className="sport-event__winner-list-slider-row" key={winner.IBCCustId}>
								<span className="sport-event__winner-list-slider-number">{idx + 1}.</span>
								<span className="sport-event__winner-list-slider-winner-id">{winner.NickName ? winner.NickName : winner.UserName}</span>
							</div>
						))}
					</div>
				</div>
				<div className="sport-event__winner-list-slider-footer">{t('lbl_KBWinList03')}</div>
			</div>
		</div>
	);
}; 


